import { fill } from 'lodash';
import { DishFirstSegmentFilter, HierarchicalAvailableCuisineCategoryFragment } from 'src/gqlReactTypings.generated.d';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import { UseExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { FilterUpdates } from '../Constants';
import { SegmentHeaderTitle } from '../styles';
import { CuisineButton, LoadingCuisineButton } from './ExploreFilterModals/CuisineFilterModal/CuisineButton';
import { useCuisineFilters } from './ExploreFilterModals/CuisineFilterModal/hooks';
import { CuisineCarousel, InlineContainer } from './ExploreFilterModals/CuisineFilterModal/styles';

const SubcuisinePickerContainer = styled(DishFirstExploreWidthLimit)`
  margin-bottom: ${Spacing.QUADRUPLE};
`;

const Header = styled.div`
  padding: ${Spacing.NONE} ${Spacing.SINGLE};
  display: flex;
  flex-direction: row;

  margin-bottom: ${Spacing.SINGLE_HALF};
  cursor: default;
`;

interface IProps {
  loading: boolean;
  allCuisineCategories?: HierarchicalAvailableCuisineCategoryFragment[];
  availableCuisineCategories: HierarchicalAvailableCuisineCategoryFragment[];
  onFiltersChange: (updates: FilterUpdates) => void;
  filters: UseExploreUrl<DishFirstSegmentFilter>;
  showFiltersInline?: boolean;
}

export const SubcuisinePickerCarousel = ({
  loading,
  allCuisineCategories,
  availableCuisineCategories,
  filters,
}: IProps): JSX.Element => {
  const {
    allSubCuisinesButtonProps,
    formattedSubCuisines,
    isSubCuisine,
    selectedCuisine,
    subCuisines,
    handleFilterChange,
  } = useCuisineFilters({
    availableCuisineCategories,
    allCuisineCategories,
    filters,
  });

  return (
    <>
      {isSubCuisine || !subCuisines.length ? null : (
        <SubcuisinePickerContainer>
          <Header>
            <SegmentHeaderTitle>{`${selectedCuisine?.title ?? 'Available'} subcuisines`}</SegmentHeaderTitle>
          </Header>
          <InlineContainer>
            <CuisineCarousel scrollSnapOnSmallScreen isLightBackground>
              {loading ? (
                fill(new Array(16), null).map((_, index) => <LoadingCuisineButton key={index} />)
              ) : (
                <>
                  <CuisineButton {...allSubCuisinesButtonProps} title={'All'} showInline />
                  {formattedSubCuisines.map(({ cuisineFilter, isSelected, rootCuisineFilter, title }) => (
                    <CuisineButton
                      cuisineFilter={cuisineFilter}
                      title={title}
                      key={cuisineFilter}
                      isSelected={isSelected}
                      onChange={handleFilterChange}
                      rootCuisineFilter={rootCuisineFilter}
                      showInline
                    />
                  ))}
                </>
              )}
            </CuisineCarousel>
          </InlineContainer>
        </SubcuisinePickerContainer>
      )}
    </>
  );
};
